import React, {
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
} from "react";

import {
  Expression,
  GridData,
  GridDataOptions,
  GridProps,
  Pager,
  Sorter,
} from "../../../../../component/DataList/schema";
import {
  getDataSource,
  getDictionaryMapper,
  getGridData,
  getPagination,
} from "../../../../../component/DataList/util";
import { Button, List } from "antd-mobile";
import { DatePicker } from "antd-mobile-v5";
import moment from "moment";
import { ClockCircleOutline, CloseCircleOutline } from "antd-mobile-icons";

const { Item } = List;
const Brief = Item.Brief;

const HistoryDataList = forwardRef(
  (
    {
      url,
      pagination,
      descriptions,
      useLegacyAPI,
      expressions,
      sorter,
      onComplete,
      onClickRow,
      rowSelectionType,
      pageSize = 10,
      render,
    }: GridProps & { render?: (item: unknown, index: number) => void },
    ref: any
  ) => {
    const searchFormRef = useRef<{ [key: string]: string }>({});
    const [innerPagination, setInnerPagination] = useState<any>({});
    const [formattedData, setFormattedData] = useState<any[]>([]);
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [keyword, setKeyword] = useState<string>("");
    const [visible, setVisible] = useState<boolean>(false);
    /**
     * 仅查询数据
     * @param pager
     * @param currentSorter
     */
    const getData = useCallback(
      async function getData(
        pager?: Pager,
        currentSorter?: Sorter,
        keyword?: string
      ): Promise<GridData> {
        const options: GridDataOptions = {
          url: `${url}&time=${keyword}`,
          dictionaryMapper: getDictionaryMapper(descriptions),
          pagination: pagination !== false,
          pager: pager,
          sorter: currentSorter && currentSorter.order ? currentSorter : sorter,
          searchForm: searchFormRef.current,
          fuzzySearch: "",
          innerDescriptions: descriptions,
        };
        if (useLegacyAPI) {
          options.expressions = expressions || [
            new Expression("数量", "count(1)"),
          ];
        }
        return await getGridData(options);
      },
      [descriptions, expressions, pagination, sorter, url, useLegacyAPI]
    );

    /**
     * 加载数据
     * @param pager
     * @param currentSorter
     */
    const loadData = useCallback(
      async function loadData(
        pager?: Pager,
        currentSorter?: Sorter,
        searchKeyword?: string
      ) {
        const gridData = await getData(
          pager,
          currentSorter,
          searchKeyword ? searchKeyword : keyword
        );
        gridData &&
          gridData.data &&
          gridData.data.length > 0 &&
          gridData.data.forEach((item, index) => {
            if (!item.uuid) item.uuid = (+new Date()).toString() + index;
          });
        if (gridData) {
          if (useLegacyAPI) {
            setInnerPagination(
              getPagination(gridData, gridData.expressions!["数量"])
            );
          } else {
            setInnerPagination(getPagination(gridData, gridData.total || 10));
          }
          const currentFormattedData = getDataSource(gridData, descriptions);
          onComplete?.(currentFormattedData);
          gridData.data.forEach((element: any) => {
            delete element.children;
          });
          setFormattedData((prevState) => {
            if (pager?.pageIndex === 1) {
              return getDataSource(gridData, descriptions);
            }

            return [...prevState, ...getDataSource(gridData, descriptions)];
          });
        }
      },
      [
        descriptions,
        getData,
        innerPagination.total,
        onComplete,
        useLegacyAPI,
        keyword,
      ]
    );

    useEffect(() => {
      loadData({ pageIndex, pageSize: pageSize }).then();
    }, [loadData, pageIndex, pageSize]);

    // 选中行数据
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    useImperativeHandle(ref, () => ({
      getCheckedItem() {
        return selectedRows;
      },
      refresh: function() {
        loadData({ pageIndex, pageSize: pageSize })
      }
    }));

    return (
      <>
        <List>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: 10,
              fontSize: 16,
              background: "#f5f5f9",
              alignItems: "center",
            }}
          >
            {/* <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flex: 1,
                background: "#fff",
                padding: "7px 12px",
                borderRadius: 24,
              }}
              onClick={() => {
                setVisible(true);
              }}
            >
              <div>
                {keyword ? (
                  keyword
                ) : (
                  <span style={{ color: "#ccc" }}>选择日期</span>
                )}
              </div>{" "}
              <ClockCircleOutline />
            </div> */}
            {/* <div style={{ width: 48, textAlign: "center" }}>
              <CloseCircleOutline
                onClick={() => {
                  setPageIndex(1);
                  setKeyword("");
                }}
              />
            </div> */}
          </div>
          <DatePicker
            visible={visible}
            onClose={() => {
              setVisible(false);
            }}
            onConfirm={(value) => {
              setPageIndex(1);
              setKeyword(moment(value).format("YYYY-MM-DD"));
            }}
          />

          {formattedData.map((item, index) =>
            render ? (
              render(item, index)
            ) : (
              <Item
                wrap
                align="top"
                multipleLine
                onClick={() => {
                  if (onClickRow) {
                    onClickRow(item);
                  } else {
                    return;
                  }
                }}
              >
                {descriptions[0]?.render ? descriptions[0]?.render(item) : item[descriptions[0].fieldName!]}
                <Brief>
                  {descriptions
                    .slice(1, descriptions.length)
                    .filter((desc) => item[desc.fieldName!])
                    .map((desc) => (
                      <div className={"whitespace-normal"}>{`${
                        desc.fieldShowName
                      }: ${item[desc.fieldName!]}`}</div>
                    ))}
                </Brief>
              </Item>
            )
          )}
        </List>
        {formattedData.length < innerPagination.total && (
          <Button
            style={{ color: "#00b578" }}
            onClick={() => {
              setPageIndex((prevState) => prevState + 1);
            }}
          >
            加载更多
          </Button>
        )}
      </>
    );
  }
);

export default HistoryDataList;
